import { useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  tagline_home: "Du Gwo Ka aux scènes internationales — KAZAJAH STUDIO façonne le son d'une génération.",
  tagline_shop: "L'âme du label en objets cultes — vinyles, merch et collections limitées signées KAZAJAH.",
  tagline_elektroka: "Quand le Gwo Ka rencontre l'électronique. La tradition guadeloupéenne propulsée dans le futur.",
  tagline_studio: "Compose, sépare, mixe, masterise — le studio professionnel ouvert à tous, propulsé par l'IA.",
  tagline_playlist: "La radio non-stop du label. Les sons qui font vibrer Milan, Paris, New York et la Guadeloupe.",
  tagline_events: "Soul Train, Ancestral Party, Black Night V.I.P. — Les soirées qui marquent les esprits depuis 30 ans.",
  tagline_community: "Ta création mérite une scène. Uploade ton son, le label valide, le monde l'écoute.",
  tagline_gallery: "Le label en images — clips, lives, sessions studio. Toutes les vidéos de nos artistes en un seul écran.",
  studio_locations: [
    { city: "Pointe-à-Pitre", place: "La Cattedrale", flag: "🇬🇵" },
    { city: "Bordeaux", place: "Studio KAZAJAH BDX", flag: "🇫🇷" },
    { city: "Paris", place: "Studio satellite", flag: "🇫🇷" },
    { city: "Milano", place: "Studio satellite", flag: "🇮🇹" },
  ],
  streaming_links: {
    spotify: "",
    youtube: "",
    soundcloud: "",
    apple_music: "",
    deezer: "",
    facebook: "",
    instagram: "",
  },
};

export default function useSiteSettings() {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    fetch(`${API}/settings`)
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (d && typeof d === 'object') {
          setSettings({ ...DEFAULTS, ...d });
        }
      })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return { settings, loaded };
}
